module.exports = new __parcel__URL__("background_menu.da73bbe4.png").toString();